module.exports = __webpack_public_path__ + "img/niicon.f81d6023.svg";